@file:OptIn(InternalResourceApi::class)

package bds_pack_manager.site.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/bds_pack_manager.site.generated.resources/"

internal val Res.string.app_description: StringResource by lazy {
      StringResource("string:app_description", "app_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 10, 111),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 10, 103),
      ))
    }

internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 122, 44),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 114, 40),
      ))
    }

internal val Res.string.main_open_directory: StringResource by lazy {
      StringResource("string:main_open_directory", "main_open_directory", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 487, 47),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 487, 47),
      ))
    }

internal val Res.string.main_open_directory_remotely: StringResource by lazy {
      StringResource("string:main_open_directory_remotely", "main_open_directory_remotely", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 434, 52),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 430, 56),
      ))
    }

internal val Res.string.main_open_directory_remotely_cancel: StringResource by lazy {
      StringResource("string:main_open_directory_remotely_cancel", "main_open_directory_remotely_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 167, 51),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 155, 51),
      ))
    }

internal val Res.string.main_open_directory_remotely_connect: StringResource by lazy {
      StringResource("string:main_open_directory_remotely_connect", "main_open_directory_remotely_connect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 219, 52),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 207, 56),
      ))
    }

internal val Res.string.main_open_directory_remotely_host: StringResource by lazy {
      StringResource("string:main_open_directory_remotely_host", "main_open_directory_remotely_host", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 272, 49),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 264, 49),
      ))
    }

internal val Res.string.main_open_directory_remotely_password: StringResource by lazy {
      StringResource("string:main_open_directory_remotely_password", "main_open_directory_remotely_password", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 322, 53),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 314, 57),
      ))
    }

internal val Res.string.main_open_directory_remotely_username: StringResource by lazy {
      StringResource("string:main_open_directory_remotely_username", "main_open_directory_remotely_username", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 376, 57),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 372, 57),
      ))
    }

internal val Res.string.main_settings: StringResource by lazy {
      StringResource("string:main_settings", "main_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 867, 29),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 855, 33),
      ))
    }

internal val Res.string.main_settings_about: StringResource by lazy {
      StringResource("string:main_settings_about", "main_settings_about", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 535, 43),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 535, 35),
      ))
    }

internal val Res.string.main_settings_theme: StringResource by lazy {
      StringResource("string:main_settings_theme", "main_settings_theme", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 823, 43),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 819, 35),
      ))
    }

internal val Res.string.main_settings_theme_contrast: StringResource by lazy {
      StringResource("string:main_settings_theme_contrast", "main_settings_theme_contrast", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 725, 48),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 725, 48),
      ))
    }

internal val Res.string.main_settings_theme_contrast_high: StringResource by lazy {
      StringResource("string:main_settings_theme_contrast_high", "main_settings_theme_contrast_high", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 579, 45),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 571, 49),
      ))
    }

internal val Res.string.main_settings_theme_contrast_medium: StringResource by lazy {
      StringResource("string:main_settings_theme_contrast_medium", "main_settings_theme_contrast_medium", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 625, 47),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 621, 51),
      ))
    }

internal val Res.string.main_settings_theme_contrast_normal: StringResource by lazy {
      StringResource("string:main_settings_theme_contrast_normal", "main_settings_theme_contrast_normal", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 673, 51),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 673, 51),
      ))
    }

internal val Res.string.main_settings_theme_dark: StringResource by lazy {
      StringResource("string:main_settings_theme_dark", "main_settings_theme_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.jsMain.cvr", 774, 48),
        ResourceItem(setOf(), "${MD}values/strings.jsMain.cvr", 774, 44),
      ))
    }

@InternalResourceApi
internal fun _collectJsMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_description", Res.string.app_description)
  map.put("app_name", Res.string.app_name)
  map.put("main_open_directory", Res.string.main_open_directory)
  map.put("main_open_directory_remotely", Res.string.main_open_directory_remotely)
  map.put("main_open_directory_remotely_cancel", Res.string.main_open_directory_remotely_cancel)
  map.put("main_open_directory_remotely_connect", Res.string.main_open_directory_remotely_connect)
  map.put("main_open_directory_remotely_host", Res.string.main_open_directory_remotely_host)
  map.put("main_open_directory_remotely_password", Res.string.main_open_directory_remotely_password)
  map.put("main_open_directory_remotely_username", Res.string.main_open_directory_remotely_username)
  map.put("main_settings", Res.string.main_settings)
  map.put("main_settings_about", Res.string.main_settings_about)
  map.put("main_settings_theme", Res.string.main_settings_theme)
  map.put("main_settings_theme_contrast", Res.string.main_settings_theme_contrast)
  map.put("main_settings_theme_contrast_high", Res.string.main_settings_theme_contrast_high)
  map.put("main_settings_theme_contrast_medium", Res.string.main_settings_theme_contrast_medium)
  map.put("main_settings_theme_contrast_normal", Res.string.main_settings_theme_contrast_normal)
  map.put("main_settings_theme_dark", Res.string.main_settings_theme_dark)
}
